export default "__VITE_ASSET__DRuiaGNf__"